import { Component } from "react";
import PropTypes from "prop-types";
import colorHelper from "../../utils/color-helper";
import { SettingsAdjust, TrashCan } from "@carbon/icons-react";

const light = "#ffffff";
const dark = "#000000";

class ColorStep extends Component {
  getHexValue(color) {
    /**
     * Convert a color object to a hex string.
     * @param {Object} color color in internal format
     * @returns {string} hex string
     */
    return colorHelper.formatter("hex")(color);
  }

  getStyle(color) {
    /**
     * Build inline style for a color swatch including readable text color.
     * @param {Object} color color value
     * @returns {Object} style object
     */
    const style = {
      backgroundColor: this.getHexValue(color),
      color:
        colorHelper.wcagContrast(color, dark) <
        colorHelper.wcagContrast(color, light)
          ? "#ffffff"
          : "#000000",
    };
    return style;
  }

  /**
   * Handle edit button click and forward selected step to parent.
   * @param {Event} e DOM event
   * @param {Object} step step object to edit
   */
  onEditStep(e, step) {
    e.preventDefault();
    this.props.onEditStep(step);
  }

  /**
   * Handle delete button click and forward selected step to parent.
   * @param {Event} e DOM event
   * @param {Object} step step object to delete
   */
  onDeleteStep(e, step) {
    e.preventDefault();
    this.props.onDeleteStep(step);
  }

  render() {
    const { step } = this.props;
    return (
      <div className="color-step">
        <div className="color-step--details">
          <h3 className="color-step--name">{step.name}</h3>
          <ul className="color-step--actions">
            <li>
              <button onClick={(e) => this.onEditStep(e, step)}>
                <SettingsAdjust />
              </button>
            </li>
            <li>
              <button onClick={(e) => this.onDeleteStep(e, step)}>
                <TrashCan />
              </button>
            </li>
          </ul>
        </div>
        <ul className="color-step--list">
          {step.colors.map((color, index) => {
            return (
              <li key={index} style={this.getStyle(color)}>
                <div>
                  <div className="color_step-contrast--dark">
                    <span aria-label="contrast ratio on black">B:</span>{" "}
                    {colorHelper.wcagContrast(color, dark).toFixed(2)}
                  </div>

                  <div className="color-step--id">{index * 10 + 10}</div>
                  <div className="color_step-contrast--light">
                    <span aria-label="contrast ratio on white">W:</span>{" "}
                    {colorHelper.wcagContrast(color, light).toFixed(2)}
                  </div>
                  <div className="color-step--hex">
                    {this.getHexValue(color)}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

ColorStep.propTypes = {
  step: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    colors: PropTypes.array,
  }),
  onDeleteStep: PropTypes.func,
  onEditStep: PropTypes.func,
  owner: PropTypes.bool,
};

ColorStep.defaultProps = {
  onDeleteStep: () => {},
  onEditStep: () => {},
  owner: false,
};

export default ColorStep;
